export class MDSpecialContext {
  start: string;
  banCharsAfterStart: string;
  banCharsBeforeStart: string;
  end: string;
  name: string;
  banCharsBeforeEnd: string;
  banCharsAfterEnd: string;

  public constructor(
    start: string,
    end: string,
    name: string,
    options?: {
      banCharsAfterStart: string;
      banCharsBeforeEnd: string;
      banCharsBeforeStart: string;
      banCharsAfterEnd: string;
    }
  ) {
    this.start = start;
    this.end = end;
    this.name = name;
    this.banCharsAfterStart = options?.banCharsAfterStart || "";
    this.banCharsBeforeEnd = options?.banCharsBeforeEnd || "";
    this.banCharsBeforeStart = options?.banCharsBeforeStart || "";
    this.banCharsAfterEnd = options?.banCharsAfterEnd || "";
  }

  public isStartOfContext(text: string, index?: number): boolean {
    index = index || text.length - 1;
    const startIndex = index - this.start.length + 1;
    if (startIndex < 0) return false;
    if (text.slice(startIndex, index + 1) !== this.start) return false;
    if (index + 1 >= text.length) return true;
    const nextChar = text[index + 1];
    if (this.banCharsAfterStart.includes(nextChar)) return false;
    if (startIndex < 1) return true;
    const prevChar = text[startIndex - 1];
    if (this.banCharsBeforeStart.includes(prevChar)) return false;
    return true;
  }

  public isEndOfContext(text: string, index?: number): boolean {
    index = index || text.length - 1;
    const startIndex = index - this.end.length + 1;
    if (startIndex < 0) return false;
    if (text.slice(startIndex, index + 1) !== this.end) return false;
    if (startIndex <= 0) return true;
    const prevChar = text[startIndex - 1];
    if (this.banCharsBeforeEnd.includes(prevChar)) return false;
    if (index + 1 >= text.length) return true;
    const nextChar = text[index + 1];
    if (this.banCharsAfterEnd.includes(nextChar)) return false;
    return true;
  }
}
